module.exports = {"141022100":"唐兴镇","141022101":"南梁镇","141022102":"里砦镇","141022103":"隆化镇","141022104":"桥上镇","141022105":"西阎镇","141022106":"王庄镇","141022200":"中卫乡","141022201":"南唐乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/141022.json
// module id = 451
// module chunks = 0